import { Clock, Shield } from 'lucide-react'
import { useSupportUserStatusQuery } from 'v2/pages/auth/queries'
import { useProfileQuery } from 'v2/pages/settings/queries'
import { useAuth } from 'v2/shared/hooks/use-auth'
import { formatTimeLeft } from 'v2/shared/utils'
import dayjs from 'v2/utils/dayjs'

/**
 * Renders a purple "Support session · 5d 2h left" pill in the app header.
 * Visible only when the currently authenticated user is the canonical Plivo
 * support account — derived from `is_internal_support_user` on the active org.
 */
export const SupportSessionPill = () => {
  const { details } = useAuth()
  const region = details?.region || ''
  const { data: profileData } = useProfileQuery()
  const isSupportUser = !!profileData?.organizations?.[0]?.is_internal_support_user
  const { data: statusResponse } = useSupportUserStatusQuery(region, isSupportUser)
  const expiresAt = statusResponse?.data?.expires_at ?? null
  const isLive = expiresAt !== null && dayjs.unix(expiresAt).isAfter(dayjs())

  if (!isSupportUser) return null

  const countdownText = isLive && expiresAt ? formatTimeLeft(expiresAt) : 'Expired'

  return (
    <div
      className="flex items-center gap-2 h-8 px-3 rounded-full border border-primary/30 bg-primary/10 text-primary text-xs-500"
      data-testid="support-session-pill"
    >
      <Shield className="h-3.5 w-3.5" />
      <span>Support session</span>
      <span className="h-3 w-px bg-primary/30" aria-hidden="true" />
      <Clock className="h-3.5 w-3.5" />
      <span data-testid="support-session-countdown">{countdownText}</span>
    </div>
  )
}
